import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { LiveClassFeedbacksService } from '../../../../shared/live-class-feedbacks/live-class-feedbacks.service';
import { FeedbackResponseDTO } from '../../../../teacher-feedback/teacher-feedback-service/private-class-feedback-dto';

@Component({
  selector: 'lp2-private-class-feedback-modal',
  templateUrl: './private-class-feedback-modal.component.html',
  styleUrls: ['./private-class-feedback-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassFeedbackModalComponent implements OnInit {
  @Input() feedbackResponseId: number;

  public feedback$ = new BehaviorSubject<FeedbackResponseDTO>(null);

  constructor(public activeModal: NgbActiveModal, private liveClassFeedbacksService: LiveClassFeedbacksService) {}

  ngOnInit() {
    this.liveClassFeedbacksService
      .getLiveClassFeedbackById(this.feedbackResponseId)
      .subscribe((feedback) => this.feedback$.next(feedback));
  }

  onClose() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-feedback-modal/private-class-feedback-modal.component.ts